import React, {useContext} from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthService } from "../../services";
import { string } from "../../helpers";
import AppContext from "../../AppContext"

const ProtectedRoute = ({ path, history, roles, component: Component, render, ...rest }) => {
  const { setIsLogedIn } = useContext(AppContext);
  return (    
    <Route
      {...rest}
      history={history}
      render={props => {
        if (!AuthService.getCurrentUser()) {
          return (
            <Redirect
              to={{
                pathname: "/account/login",
                state: { from: props.location }
              }}
            />
          );
        }
        else if (!string.containsAny(AuthService.getRole(), roles)) { // Check roles, If the user doesn't contain any role, redirect the user to page 403
          return (
            <Redirect
              to={{
                pathname: "/403",
                state: { from: props.location }
              }}
            />
          );    
        }
        else {
          setIsLogedIn(true)
          return Component ? <Component {...props} /> : render(props); 
        }          
      }}
    />
  );
};

export default ProtectedRoute;
